import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Typography, Icon, Row, Col, Spin, Card, Tag, Select, Radio, Input, Form, Button } from 'antd'
import { changeFormatdate } from '../../../utils/formatdate'
const { Text, Title } = Typography
const { Search } = Input;

class QualityDocumentDetail extends React.PureComponent {

    checkStatus = (value) =>{
        if(value == 'PUBLIC'){
            return <>
                        <Icon type="global" className="mr-2" />
                        สาธารณะ
                    </>
        }else if(value == 'INTERNAL'){
            return  <>
                        <Icon type="team" className="mr-2" />
                        ภายใน
                    </>
        }else if(value == 'PRIVATE'){
            return 'ยังไม่เผยแพร่'
        }
    }

    fetchListDetail = (id) =>{
        const { fetchListKCMHDocumentDetail } = this.props

        fetchListKCMHDocumentDetail(id)
    }

    async componentDidMount() {
        // await this.fetchListDocumen(null)
    }  
	render() {
        const { detailDocument } = this.props
		return (
            detailDocument.map((value, keys) =>
            <>
                <Row className="mb-3">
                    <Col>
                        <Link onClick={ () => this.fetchListDetail(value.id)}>
                            <Card >
                                <div>
                                    <Title level={4} className="mr-2 pr-1 mb-1" style={{ display: "inline-block" }}>
                                        {value.title}
                                    </Title>
                                    <Text>
                                        ( เอกสารลงวันที่ { changeFormatdate(value.activeDate) } )
                                        {
                                            value.systemName &&
                                            <Tag className="ml-3">{ value.systemName }</Tag>
                                        }
                                    </Text>
                                        <br></br>
                                </div>
                                <div className="mb-3">
                                    <Row>
                                        <Col xs={20} md={20}>
                                            <Text className="color-orange">รายละเอียดเพิ่มเติม</Text><br></br>
                                        </Col>
                                        <Col xs={4} md={4} align="right">
                                            <Icon type="file-pdf" className="color-black" />
                                        </Col>
                                    </Row>
                                </div>
                                {/* {
                                    value.division &&
                                    <div className="mb-3">
                                        <Text>{ value.division }</Text>
                                    </div>
                                } */}
                                <Text className="font-italic">
                                    รับข้อมูลมาจากระบบเอกสารอิเล็กทรอนิกส์ ณ วันที่ { changeFormatdate(value.updatedAt) } 
                                    <Tag className="color-white ml-3" style={{ backgroundColor:"#f1b341",border:"0" }}>
                                        { this.checkStatus(value.status) }
                                    </Tag> 
                                </Text><br></br>
                            </Card>
                        </Link>
                    </Col>
                </Row>
            </>
		))
	}
}

export default QualityDocumentDetail